export default {
  Driver: "Driver",
  AddDriver: "AddDriver",
  editDriver: "EditDriver",
  driverProfile: "DriverProfile",
};
